export default "__VITE_ASSET__ca5c0022__"